<script>
  import Movie from "./Movie.svelte";
  let value = "";
  let response = [];

  const handleInput = (event) => (value = event.target.value);
  $: if (value.length > 2) {
    //loading = true;
    response = fetch(`https://www.omdbapi.com/?s=${value}&apikey=9fe8edd8`)
      //.then((res) => (res.ok ? res : Promise.reject(res)))
      //.then((res) => !res.ok() && new Error("Error"))
      .then((res) => res.json())
      .then((apiResponse) => apiResponse.Search || []);
  }
</script>

<div class="mb-3">
  <input
    class="form-control"
    id="formGroupExampleInput"
    placeholder="Buscar Películas..."
    type="text"
    {value}
    on:input={handleInput}
  />
</div>

{#await response}
  <p>Cargando...</p>
{:then movies}
  <div class="container text-center">
    <div class="row">
      {#each movies as { Title, Poster, Year }, index}
        <Movie title={Title} poster={Poster} year={Year} {index} />
      {:else}
        <strong>No hay resultados</strong>
      {/each}
    </div>
  </div>
{:catch error}
  <p>❌ Ha ocurrido un error</p>
{/await}
